module.exports = __webpack_public_path__ + "img/haft-poznan-14.6860403c.jpg";